import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
const ZodFormContext = React.createContext(null);
export function ZodFormProvider({ value, children, }) {
    return _jsx(ZodFormContext.Provider, { value: value, children: children });
}
export function useZodFormContext() {
    const ctx = React.useContext(ZodFormContext);
    if (!ctx) {
        throw new Error('useZodFormContext must be used inside <ZodForm>.');
    }
    return ctx;
}
//# sourceMappingURL=context.js.map